import orderRoutes from '@/router/management/order';

import claimRoutes from './claim';
import dashboardRoutes from './dashboard';
import productRoutes from './product';
import sellerRoutes from './seller';

// routers 내보낼 때 사용
const managementRouters = [...dashboardRoutes, ...productRoutes, ...orderRoutes, ...claimRoutes, ...sellerRoutes];

export default managementRouters;
